/* Display Shopify's actual totals. This module never changes cart prices. */
(function(root) {
  'use strict';

  var config = root.veraNoaConfig || {};
  var target = String(config.productId || '');
  var unitPrice = Number(config.unitPrice || 2995);
  var discounts = {
    two: Number(config.discounts && config.discounts.two || 995),
    three: Number(config.discounts && config.discounts.three || 2990)
  };

  function isTarget(item) {
    return !!target && String(item.product_id) === target;
  }

  function offerTotal(quantity) {
    var count = Number(quantity);
    if (!Number.isSafeInteger(count) || count < 1) return null;
    return count * unitPrice - (count >= 3 ? discounts.three : count === 2 ? discounts.two : 0);
  }

  function summary(cart) {
    var result = {quantity: 0, total: 0, original: 0, applied: false, state: 'is-start', message: '', productUrl: config.productUrl || ''};
    (cart.items || []).forEach(function(item) {
      if (!isTarget(item)) return;
      result.quantity += Number(item.quantity);
      result.total += Number(item.final_line_price);
      result.original += Number(item.original_line_price);
    });

    // Ajax line totals do not prove an order discount's allocation. Only claim
    // an unlocked offer when Shopify confirms the exact isolated line prices.
    result.applied = result.quantity > 0 &&
      result.original === result.quantity * unitPrice &&
      result.total === offerTotal(result.quantity) &&
      !(cart.cart_level_discount_applications || []).length;

    if (result.quantity === 1) {
      result.message = 'Añade otro color y llévate 2 por 49,95 €';
    } else if (result.quantity === 2 && result.applied) {
      result.state = 'is-ten';
      result.message = '¡Oferta desbloqueada! Añade un tercer color por solo 10 € más';
    } else if (result.quantity === 3 && result.applied) {
      result.state = 'is-fifteen';
      result.message = '¡Tienes nuestro mejor precio!';
    } else if (result.quantity > 3 && result.applied) {
      result.state = 'is-fifteen';
      result.message = 'Oferta de 3 bolsos aplicada; unidades adicionales a precio normal';
    } else if (result.quantity > 1) {
      result.message = 'Revisa el total de tus bolsos Noa: la oferta aún no está aplicada.';
    }
    return result;
  }

  function eligibleCount(cart) {
    var tres = root.VeraTresAlmas;
    var count = tres ? tres.summary(cart).eligibleCount : cart.item_count;
    // Keep the existing Tres Almas eligibility and every non-Noa cart intact.
    (cart.items || []).forEach(function(item) {
      if (isTarget(item) && !(tres && tres.isTarget(item))) count -= Number(item.quantity);
    });
    return Math.max(0, count);
  }

  root.VeraNoaCart = {isTarget: isTarget, offerTotal: offerTotal, summary: summary, eligibleCount: eligibleCount};
  if (typeof module !== 'undefined') module.exports = root.VeraNoaCart;
})(typeof window !== 'undefined' ? window : globalThis);
